import acpBlockSensitiveDirective from './acp-block-sensitive-directive';
import acpImageSrcDirective from './acp-image-src-directive';
import acpTrackingDirective from './acp-tracking-directive';

export default function (core) {
  core.directive('acpBlockSensitive', acpBlockSensitiveDirective);
  core.directive('acpImageSrc', acpImageSrcDirective);
  core.directive('acpTracking', acpTrackingDirective);
}
